/* eslint-disable complexity */
/* eslint-disable max-statements */
/* eslint-disable consistent-return */
import React, { useState, useEffect, useCallback } from 'react';
// import Autocomplete from 'react-autocomplete';
import axios from 'axios';
import Loader from '../Common/Loader';
import constants from '../../constants';
import { cookieStorageUtility } from '../../utils/utilityFunctions';
import { useParams, useNavigate } from 'react-router-dom';


const { serverUrl, ENCRYPTOR_KEY } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const initialHotelDetail = {
  hotelId: '',
  detailTitle: '',
  actualName: '',
  hotelCode: '',
  selectedPms: 1,
  categoryId: '',
  rating: '0',
  description: '',
  status: '1',
  syncAllowed: '0',
  contactName: '',
  email: '',
  mobile: '',
  landline: '',
  bookingEmail: '',
  countryId: '',
  cityId: '',
  cityData: [],
  stateId: '',
  cityName: '',
  locality: '',
  address: '',
  zipcode: '',
  lat: '',
  long: '',
  geoUrl: 'https://www.google.co.in/maps/place/',
  connectedOta: []
};

const PropertySetup = (props) => {
  const navigate = useNavigate();
  const [hotelDetail, setHotelDetail] = useState(initialHotelDetail);
  const [cityList, setCityList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [pmsList, setPmsList] = useState([]);
  const [flag, setFlag] = useState(false);
  const [showSearchLoader, setShowSearchLoader] = useState(false);
  const [type, setType] = useState('error');
  const [message, setMessage] = useState('');
  const [showUILoader, setShowUILoader] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const { hotelId } = useParams();

  useEffect(() => {
    getMasterList();
    if (typeof hotelId !== 'undefined' && hotelId !== '') {
      getHotelDetail(hotelId);
    }
    // eslint-disable-next-line
  }, []);

  const getMasterList = () => {
    setShowUILoader(true);
    axios(serverUrl + 'common/masterlist', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      }
    })
      .then(response => {
        if (response.status === 200) {
          setCategoryList(response.data.categoryList);
          setCountryList(response.data.countryList);
          setPmsList(response.data.pmsList);
        } else {
          setFlag(true);
          setType('error');
          setMessage(response.data.message);
          setTimeout(() => setFlag(false), 5000);
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  };

  const getHotelDetail = (hotelId) => {
    axios(serverUrl + 'property/gethoteldetail', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { hotelId }
    })
      .then(response => {
        if (response.data.status === 'success') {
          setHotelDetail(response.data.data);
        } else {
          showMessage('error', response.data.message);
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  };

  const handleValueChange = (type, e) => {
    setHotelDetail(prev => ({ ...prev, [type]: e.target.value }));
  };

  const showMessage = (type, msg) => {
    setFlag(true);
    setType(type);
    setMessage(msg);
    setTimeout(() => setFlag(false), 5000);
  };

  const checkValue = (val) => {
    return typeof val === 'undefined' || val === '';
  };

  const validateParam = () => {
    if (checkValue(hotelDetail.detailTitle)) {
      showMessage('error', 'Property display name is required.');
      return false;
    }
    if (checkValue(hotelDetail.hotelCode)) {
      showMessage('error', 'Property code is required.');
      return false;
    }
    if (checkValue(hotelDetail.status)) {
      showMessage('error', 'Please select property status.');
      return false;
    }
    if (checkValue(hotelDetail.syncAllowed)) {
      showMessage('error', 'Please select property type.');
      return false;
    }
    if (checkValue(hotelDetail.contactName)) {
      showMessage('error', 'Property contact person is required.');
      return false;
    }
    if (checkValue(hotelDetail.email)) {
      showMessage('error', 'Property contact email is required.');
      return false;
    }
    var emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (!hotelDetail.email.match(emailRegex)) {
      showMessage('error', 'Please enter valid contact email id.');
      return false;
    }
    if (checkValue(hotelDetail.mobile)) {
      showMessage('error', 'Property contact person mobile no is required.');
      return false;
    }
    var moblieRegex = /^\d{10}$/;
    if (!hotelDetail.mobile.match(moblieRegex)) {
      showMessage('error', 'Please enter 10 digit valid mobile no.');
      return false;
    }
    var landLineRegex = /^\d{10,12}$/;
    if (hotelDetail.landline !== '' && !hotelDetail.landline.match(landLineRegex)) {
      showMessage('error', 'Please enter valid landline no.');
      return false;
    }
    if (checkValue(hotelDetail.countryId)) {
      showMessage('error', 'Property location country is required.');
      return false;
    }
    if (checkValue(hotelDetail.cityId)) {
      showMessage('error', 'Property location city is required.');
      return false;
    }
    var zipRegex = /^[0-9]+$/;
    if (hotelDetail.zipcode !== '' && !hotelDetail.zipcode.match(zipRegex)) {
      showMessage('error', 'Please enter valid zipcode.');
      return false;
    }
    var latRegex = /^[-]?(([0-8]?[0-9])\.(\d+))|(90(\.0+)?)$/;
    var lngRegex = /^[-]?((((1[0-7][0-9])|([0-9]?[0-9]))\.(\d+))|180(\.0+)?)$/;
    if (hotelDetail.lat !== '' && !hotelDetail.lat.match(latRegex)) {
      showMessage('error', 'Please enter valid latitude.');
      return false;
    }
    if (hotelDetail.long !== '' && !hotelDetail.long.match(lngRegex)) {
      showMessage('error', 'Please enter valid longitude.');
      return false;
    }
    return true;
  };

  const updateHotel = () => {
    if (validateParam()) {
      const { history } = props;
      setShowUILoader(true);
      setShowPopup(false);
      axios(serverUrl + 'property/updatehotel', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          token: btoa(authUserId + '|' + encryptedToken)
        },
        data: hotelDetail
      })
        .then(response => {
          if (response.data.status === 'success') {
            showMessage('success', response.data.message);
            navigate('/property');
          } else {
            showMessage('error', response.data.message);
          }
          setShowUILoader(false);
        })
        .catch(error => {
          console.log(error);
          setShowUILoader(false);
        });
    }
  };

  const submitPropertyDetails = (type) => {
    if (type === 'cancel') {
      setShowPopup(false);
    } else {
      if (Object.keys(hotelDetail.connectedOta).length > 0 && hotelDetail.status === 0) {
        setShowPopup(true);
      } else {
        updateHotel();
      }
    }
  };

  const createHotel = () => {
    if (validateParam()) {
      setShowUILoader(true);
      const { history } = props;
      axios(serverUrl + 'property/createhotel', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          token: btoa(authUserId + '|' + encryptedToken)
        },
        data: hotelDetail
      })
        .then(response => {
          if (response.data.status === 'success') {
            showMessage('success', response.data.message);
            navigate('/property');
          } else {
            showMessage('error', response.data.message);
          }
          setShowUILoader(false);
        })
        .catch(error => {
          console.log(error);
          setShowUILoader(false);
        });
    }
  };

  const handleSearch = (cityname) => {
    if (typeof cityname === 'undefined' || cityname === '') {
      return;
    }
    if (hotelDetail.countryId === 0) {
      showMessage('error', 'Please select country.');
      return;
    }
    if (cityname.length > 2) {
      getCityList(cityname);
    }
  };

  const getCityList = (cityName) => {
    setShowSearchLoader(true);
    axios(serverUrl + 'common/citylist', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { cityName: cityName, countryId: hotelDetail.countryId }
    })
      .then(response => {
        if (response.data.status === 'success') {
          setShowSearchLoader(false);
          setCityList(response.data.data.cityList);
        } else {
          showMessage('error', response.data.message);
        }
        setShowSearchLoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowSearchLoader(false);
      });
  };

  const onChange = (e) => {
    let cityName = e.target.value;
    setHotelDetail(prev => ({ ...prev, cityName }));
    getCityList(cityName);
  };

  const onSelect = (selectedVal, item) => {
    setHotelDetail(prev => ({
      ...prev,
      cityName: selectedVal,
      cityId: item.city_id,
      stateId: item.state_id ? item.state_id : 0,
      countryId: item.country_id
    }));
  };

  const renderItem = (item, isHighlighted) => (
    <div key={item.city_id} className="pad10 width100" style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
      {item.city}
    </div>
  );

  const getItemValue = (item) => `${item.city}`;

  const handleAsyncCity = (selected) => {
    Object.keys(selected).forEach(id => {
      setHotelDetail(prev => ({
        ...prev,
        cityId: selected[id].city_id,
        countryId: selected[id].country_id,
        stateId: selected[id].state_id ? selected[id].state_id : 0,
        cityName: selected[id].state ? selected[id].city + ', ' + selected[id].state : selected[id].city
      }));
    });
  };

  const connectedOtaList = () => {
    if (Object.keys(hotelDetail.connectedOta).length > 0) {
      return Object.keys(hotelDetail.connectedOta).map((id, i) => (
        <React.Fragment key={id}>
          <div className="frm  marg_bottom5 tcap">
            {i + 1}. {hotelDetail.connectedOta[id].channel_type}
          </div>
        </React.Fragment>
      ));
    }
  };

  return (
    <React.Fragment>
      {showUILoader ? <Loader /> : ''}
      <div className="container_fluid topheading pad_lft_rht25 pad_top_bot15 text-start">
        <div className="row">
          <div className="col-xs">
            <div className="d-full-height justify-content-center fnt18 tu">
              {hotelDetail.hotelId > 0 ? 'Property Settings' : 'Add Hotel'}
            </div>
          </div>
        </div>
      </div>
      {flag ? (
        <div className={`alert_col posfixed pad10 tc fnt16 bld ${type === 'error' ? 'danger' : 'success'}`}>{message}</div>
      ) : ''}
      <div className="container_fluid pad_lft_rht20 padtop25 text-start">
        <div className="container">
          <div className="cover marg_bottom20">
            <div className="row">
              <div className="col-xs-12 col-md-4 marg_bottom15">
                <label className="marg_bottom5">
                  {' '}
                  Property Title (Display Name) <span className="color5">*</span>
                </label>
                <div className="frm border_all_1 border_color_1">
                  <input
                    type="text"
                    className="input pad_lft_rht5"
                    value={hotelDetail.detailTitle}
                    onChange={e => handleValueChange('detailTitle', e)}
                  />
                </div>
              </div>
              <div className="col-xs-12 col-md-4 marg_bottom15">
                <label className="marg_bottom5">
                  {' '}
                  Propety Code <span className="color5">*</span>
                </label>
                <div className="frm border_all_1 border_color_1">
                  <input
                    type="text"
                    className="input pad_lft_rht5"
                    value={hotelDetail.hotelCode}
                    onChange={e => handleValueChange('hotelCode', e)}
                  />
                </div>
              </div>
              <div className="col-xs-12 col-md-4 marg_bottom15">
                <label className="marg_bottom5"> Propety Category </label>
                <div className="frm border_all_1 border_color_1">
                  {' '}
                  <span className="ficon pad_lft_rht10">
                    <i className="fa fa-chevron-down"></i>
                  </span>
                  <select
                    className="input pad_lft_rht10"
                    value={hotelDetail.categoryId}
                    onChange={e => handleValueChange('categoryId', e)}
                  >
                    <option value="">Select Property Category</option>
                    {Object.keys(categoryList).map((id, i) => {
                      return (
                        <option key={i} value={categoryList[id].category_id}>
                          {categoryList[id].category}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="col-xs-12 col-md-8 marg_bottom15">
                <label className="marg_bottom5"> Actual Property Name </label>
                <div className="frm border_all_1 border_color_1">
                  <input
                    type="text"
                    className="input pad_lft_rht5"
                    value={hotelDetail.actualName}
                    onChange={e => handleValueChange('actualName', e)}
                  />
                </div>
              </div>

              <div className="col-xs-12 col-md-4 marg_bottom15">
                <label className="marg_bottom5"> Propety Rating </label>
                <div className="frm border_all_1 border_color_1">
                  {' '}
                  <span className="ficon pad_lft_rht10">
                    <i className="fa fa-chevron-down"></i>
                  </span>
                  <select
                    className="input pad_lft_rht10"
                    value={hotelDetail.rating}
                    onChange={e => handleValueChange('rating', e)}
                  >
                    <option value="0">Select Rating</option>
                    <option value="1">1 Star</option>
                    <option value="2">2 Star</option>
                    <option value="3">3 Star</option>
                    <option value="4">4 Star</option>
                    <option value="5">5 Star</option>
                  </select>
                </div>
              </div>
              <div className="col-xs-12 col-md-12 marg_bottom15">
                <label className="marg_bottom5"> Description </label>
                <div className="frm border_all_1 border_color_1">
                  <textarea
                    className="tera"
                    value={hotelDetail.description}
                    onChange={e => handleValueChange('description', e)}
                  ></textarea>
                </div>
              </div>
              <div className="col-xs-12 col-md-4 marg_bottom15">
                <label className="marg_bottom5">
                  {' '}
                  Property Status<span className="color5">*</span>
                </label>
                <div className="frm border_all_1 border_color_1">
                  {' '}
                  <span className="ficon pad_lft_rht10">
                    <i className="fa fa-chevron-down"></i>
                  </span>
                  <select
                    className="input pad_lft_rht10"
                    value={hotelDetail.status}
                    onChange={e => handleValueChange('status', e)}
                  >
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                </div>
              </div>
              <div className="col-xs-12 col-md-4 marg_bottom15">
                <label className="marg_bottom5">
                  {' '}
                  Property Type<span className="color5">*</span>
                </label>
                <div className="frm border_all_1 border_color_1">
                  {' '}
                  <span className="ficon pad_lft_rht10">
                    <i className="fa fa-chevron-down"></i>
                  </span>
                  <select
                    className="input pad_lft_rht10"
                    value={hotelDetail.syncAllowed}
                    onChange={e => handleValueChange('syncAllowed', e)}
                  >
                    <option value="0">Channel Manager Managed</option>
                    <option value="1">Connected with PMS</option>
                  </select>
                </div>
              </div>
              <div
                className={`col-xs-12 col-md-4 marg_bottom15 ${
                  hotelDetail.syncAllowed === 1 ? '' : 'hides'
                }`}
              >
                <label className="marg_bottom5"> Select PMS </label>
                <div className="frm border_all_1 border_color_1">
                  {' '}
                  <span className="ficon pad_lft_rht10">
                    <i className="fa fa-chevron-down"></i>
                  </span>
                  <select
                    className="input pad_lft_rht10"
                    value={hotelDetail.selectedPms}
                    onChange={e => handleValueChange('selectedPms', e)}
                  >
                    {Object.keys(pmsList).map(key => {
                      return (
                        <option key={key} value={pmsList[key].id}>
                          {pmsList[key].name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="cover marg_bottom20">
            <div className="ovr marg_bottom15 bld fnt16">Contact Details</div>
            <div className="row">
              <div className="col-xs-12 col-md-4 marg_bottom15">
                <label className="marg_bottom5">
                  {' '}
                  Contact Person<span className="color5">*</span>
                </label>
                <div className="frm border_all_1 border_color_1">
                  <input
                    type="text"
                    className="input pad_lft_rht5"
                    value={hotelDetail.contactName}
                    onChange={e => handleValueChange('contactName', e)}
                  />
                </div>
              </div>
              <div className="col-xs-12 col-md-4 marg_bottom15">
                <label className="marg_bottom5">
                  {' '}
                  Email<span className="color5">*</span>
                </label>
                <div className="frm border_all_1 border_color_1">
                  <input
                    type="text"
                    className="input pad_lft_rht5"
                    value={hotelDetail.email}
                    onChange={e => handleValueChange('email', e)}
                  />
                </div>
              </div>
              <div className="col-xs-12 col-md-4 marg_bottom15">
                <label className="marg_bottom5">
                  {' '}
                  Mobile No.<span className="color5">*</span>{' '}
                </label>
                <div className="frm border_all_1 border_color_1">
                  <input
                    type="text"
                    className="input pad_lft_rht5"
                    value={hotelDetail.mobile}
                    onChange={e => handleValueChange('mobile', e)}
                  />
                </div>
              </div>
              <div className="col-xs-12 col-md-4 marg_bottom15">
                <label className="marg_bottom5"> Landline No. </label>
                <div className="frm border_all_1 border_color_1">
                  <input
                    type="text"
                    className="input pad_lft_rht5"
                    value={hotelDetail.landline}
                    onChange={e => handleValueChange('landline', e)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="cover marg_bottom20">
            <div className="ovr marg_bottom15 bld fnt16">Location</div>
            <div className="row">
              <div className="col-xs-12 col-md-4 marg_bottom15">
                <label className="marg_bottom5">
                  Country<span className="color5">*</span>
                </label>
                <div className="frm border_all_1 border_color_1">
                  {' '}
                  <span className="ficon pad_lft_rht10">
                    <i className="fa fa-chevron-down"></i>
                  </span>
                  <select
                    className="input pad_lft_rht10"
                    value={hotelDetail.countryId}
                    onChange={e => handleValueChange('countryId', e)}
                  >
                    <option value="">Select Country</option>
                    {Object.keys(countryList).map((id, i) => {
                      return (
                        <option key={i} value={countryList[id].country_id}>
                          {countryList[id].country}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="col-xs-12 col-md-4 marg_bottom15">
                <label className="marg_bottom5">
                  {' '}
                  City <span className="color5">*</span>
                </label>
                <div className="frm border_all_1 border_color_1 pad_bottom8  padtop5 pad_left7">
                  <div className='cityDropDown'>
                    {/* <Autocomplete
                      getItemValue={getItemValue}
                      items={cityList}
                      renderItem={renderItem}
                      value={hotelDetail.cityName}
                      onChange={onChange}
                      onSelect={onSelect}
                      menuStyle={{ weight: '100%',
                        height: '200px',
                        width: '320px',
                        position: 'absolute',
                        top: '27px',
                        left: '-8px',
                        overflow: 'auto' }}
                      wrapperStyle={{
                        position: 'relative',
                        display: 'inline-block',
                        zIndex: '998' }}
                    /> */}
                  </div>
                </div>
              </div>

              <div className="col-xs-12 col-md-4 marg_bottom15">
                <label className="marg_bottom5"> Locality </label>
                <div className="frm border_all_1 border_color_1">
                  <input
                    type="text"
                    className="input pad_lft_rht5"
                    value={hotelDetail.locality}
                    onChange={e => handleValueChange('locality', e)}
                  />
                </div>
              </div>
              <div className="col-xs-12 col-md-8 marg_bottom15">
                <label className="marg_bottom5">
                  {' '}
                  Address <span className="color5">*</span>
                </label>
                <div className="frm border_all_1 border_color_1">
                  <input
                    type="text"
                    className="input pad_lft_rht5"
                    value={hotelDetail.address}
                    onChange={e => handleValueChange('address', e)}
                  />
                </div>
              </div>

              <div className="col-xs-12 col-md-4 marg_bottom15">
                <label className="marg_bottom5"> Zip / Postal Code </label>
                <div className="frm border_all_1 border_color_1">
                  <input
                    type="text"
                    className="input pad_lft_rht5"
                    value={hotelDetail.zipcode}
                    onChange={e => handleValueChange('zipcode', e)}
                  />
                </div>
              </div>

              <div className="col-xs-12 col-md-4 marg_bottom15">
                <label className="marg_bottom5">Latitude </label>
                <div className="frm border_all_1 border_color_1">
                  <input
                    type="text"
                    className="input pad_lft_rht5"
                    value={hotelDetail.lat}
                    onChange={e => handleValueChange('lat', e)}
                  />
                </div>
              </div>

              <div className="col-xs-12 col-md-4 marg_bottom15">
                <label className="marg_bottom5">Longitude </label>
                <div className="frm border_all_1 border_color_1">
                  <input
                    type="text"
                    className="input pad_lft_rht5"
                    value={hotelDetail.long}
                    onChange={e => handleValueChange('long', e)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="cover marg_bottom15">
            <div className="row justify-content-end gutters-5">
              <div className="col-xs-auto">
                {' '}
                {hotelDetail.hotelId > 0 ? (
                  <input
                    value="Update"
                    className="btn1 pad_top_bot7 pad_lft_rht20 fnt14 cursor_p"
                    type="button"
                    onClick={() => submitPropertyDetails()}
                  />
                ) : (
                  <input
                    value="Save"
                    className="btn1 pad_top_bot7 pad_lft_rht20 fnt14 cursor_p"
                    type="button"
                    onClick={() => createHotel()}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`modal_wrap posfixed ${showPopup === true ? '' : 'hides'}`}>
        <div className="modal_overlay transbg1">&nbsp;</div>
        <div className="pop_colum">
          <div className="pop_inner">
            <div className="apndwrap wdhpx400 shwd2 bg1 pad30 round5 ovr zIndex999">
              <div
                className="close_popup facnt full-round bgcolr6"
                onClick={() => {
                  setShowPopup(false);
                }}
              >
                {' '}
                <i className="fa fa-times txtcolr1"></i>
              </div>

              <div className="wrapper">
                <div className="cover marg_bottom10">
                  <div className="cover marg_bottom15">
                    <label className="ovr marg_bottom7 bld">Connected OTA </label>
                    {connectedOtaList()}
                    <div>
                      <span className="bld">Note :</span> Above ota are connected, if you inactive property, then all ota
                      inventory will be stop sell.
                    </div>
                  </div>

                  <div className="cover">
                    <div className="inline">
                      <input
                        value="Submit"
                        className="btn1 pad_top_bot7 pad_lft_rht20 tc fnt16 cursor_p marg_right30"
                        onClick={() => updateHotel()}
                        type="button"
                      />
                    </div>
                    <div className="inline">
                      <input
                        value="Cancel"
                        className="btn1 pad_top_bot7 pad_lft_rht20 tc fnt16 cursor_p"
                        onClick={() => submitPropertyDetails('cancel')}
                        type="button"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PropertySetup;
